import type { MyDataFormValues } from '../types/my-data-form-values.type';

// Only what changes is sent: an unchanged email or an empty new password are
// left as they are.
export const myDataForm2ApiMapper = (
  { email, newPassword, currentPassword }: Readonly<MyDataFormValues>,
  initialEmail: string,
) => ({
  currentPassword,
  email: email.trim() && email.trim() !== initialEmail ? email.trim() : null,
  newPassword: newPassword || null,
});
